import { formatParisDateTime } from '@flux/shared';
import type { JSX } from 'react';

export interface TimelineEntry {
  at: string;
  code: string;
  message: string;
  userName?: string | null;
}

/**
 * Une entrée d'historique horodatée — même rendu pour la timeline d'une
 * commande (`02` §4) et pour celle d'une facture Pennylane (`02` §3, fiche
 * facture).
 */
export function TimelineEntryRow({ entry }: { entry: TimelineEntry }): JSX.Element {
  return (
    <li className="relative flex flex-col gap-0.5 border-l border-border pb-4 pl-4 last:pb-0 before:absolute before:-left-[3.5px] before:top-1.5 before:size-1.5 before:rounded-full before:bg-muted-foreground/50">
      <div className="flex flex-wrap items-baseline gap-2">
        <span className="text-xs font-medium tabular-nums text-muted-foreground">
          {formatParisDateTime(new Date(entry.at))}
        </span>
        <span className="font-mono text-xs text-muted-foreground">{entry.code}</span>
      </div>
      <p className="text-sm">
        {entry.message}
        {entry.userName ? (
          <span className="text-muted-foreground"> — par {entry.userName}</span>
        ) : null}
      </p>
    </li>
  );
}
